/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Date: 2021-06-24
 * Copyright All Rights Reserved
 */
import { keyBy } from 'lodash/fp';
import numeral from 'numeral';
import getDaysBestFormat from 'support/getDaysBestFormat';

export const REPAIR_COSTS_ID = 'repairCostDollars';
export const REOCCUPANCY_TIME_ID = 'reoccupancyTime';
export const FUNCTIONAL_RECOVERY_TIME_ID = 'functionalRecoveryTime';
export const FULL_REPAIR_TIME_ID = 'fullRepairTime';
export const INSURED_LOSS_TOTAL_ID = 'insuredLossTotal';
export const CLIENT_LOSS_TOTAL_ID = 'clientLossTotal';
export const OVERLIMIT_LOSS_TOTAL_ID = 'overlimitLossTotal';

const convertToPercent = value => (
  value !== undefined
    ? numeral(value).format('%')
    : ''
);
const dollars = value => numeral(value).format('$0,0');
const convertToDaysBestFormat = value => `${getDaysBestFormat(Math.round(value))}`;
const sqFtDays = value => `${numeral(value).format('0,0')} sf-days`;

export const performanceMetricsArray = [
  {
    name: 'Ground Up Loss',
    value: REPAIR_COSTS_ID,
    format: convertToPercent,
    aggFormat: dollars,
  },
  {
    name: 'Insured Loss',
    value: INSURED_LOSS_TOTAL_ID,
    format: convertToPercent,
    aggFormat: dollars,
  },
  {
    name: 'Client Loss',
    value: CLIENT_LOSS_TOTAL_ID,
    format: convertToPercent,
    aggFormat: dollars,
  },
  {
    name: 'Over Limit Loss',
    value: OVERLIMIT_LOSS_TOTAL_ID,
    format: convertToPercent,
    aggFormat: dollars,
  },
  {
    name: 'Reoccupancy Time',
    value: REOCCUPANCY_TIME_ID,
    format: convertToDaysBestFormat,
    aggFormat: sqFtDays,
  },
  {
    name: 'Functional Recovery Time',
    value: FUNCTIONAL_RECOVERY_TIME_ID,
    format: convertToDaysBestFormat,
    aggFormat: sqFtDays,
  },
  {
    name: 'Full Repair Time',
    value: FULL_REPAIR_TIME_ID,
    format: convertToDaysBestFormat,
    aggFormat: sqFtDays,
  },
];

export const performanceMetricsById = keyBy('value', performanceMetricsArray);



// WEBPACK FOOTER //
// ./js/constants/performanceMetrics.js